import { isAxiosError } from 'axios';

/** Retrying an unchanged recommendation request cannot fix a rejected public contract. */
export function isRecommendationRequestRejected(error: unknown): boolean {
  return isAxiosError(error) && [400, 404].includes(error.response?.status ?? 0);
}
